// src/admin/components/RecentPostsWidget.jsx

import { useTheme } from "../../context/ThemeContext";

export default function RecentPostsWidget({ posts = [] }) {

  const { isDark } = useTheme();

  return (
    <div
      className={`
        rounded-3xl
        border
        p-6
        ${
          isDark
            ? "bg-white/5 border-white/10"
            : "bg-white border-gray-200"
        }
      `}
    >
      <div className="flex items-center justify-between mb-6">

        <h2 className="text-xl font-semibold">
          Recent Posts
        </h2>

      </div>

      <div className="space-y-4">

        {posts.map((post) => (

          <div
            key={post.id}
            className={`
              flex
              items-center
              justify-between
              p-4
              rounded-xl
              ${
                isDark
                  ? "bg-white/5"
                  : "bg-gray-50"
              }
            `}
          >
            <div>

              <h3 className="font-medium">
                {post.title}
              </h3>

              <p
                className={`
                  text-sm
                  ${
                    isDark
                      ? "text-gray-400"
                      : "text-gray-500"
                  }
                `}
              >
                {post.category}
              </p>

            </div>

            <span
              className={`
                px-3
                py-1
                rounded-full
                text-xs
                font-medium
                ${
                  post.status === "published"
                    ? "bg-green-500/20 text-green-400"
                    : "bg-yellow-500/20 text-yellow-400"
                }
              `}
            >
              {post.status}
            </span>

          </div>

        ))}

      </div>
    </div>
  );
}